import { Component, OnInit, Input, ViewChild, EventEmitter, Output, OnDestroy } from '@angular/core';
import { ModalController, PopoverController } from '@ionic/angular';
import { ColumnMode, DatatableComponent, SelectionType } from '@swimlane/ngx-datatable';
import { Subscription } from 'rxjs';

import { SupplierCommentUpdateDataBase, IssuesFilterSupplier, QuproList, IssueSupplier, QuproServiceError, BaseUser } from '@arpada/arp-lib-common-qupro';

import { PortalProveedorService, MessagesService, GeneralPopulateService, IssuePopulateService, UiService  } from '../../../services/api.services';
import { IssueFront, Page } from '../../../models/api.models';

import { IssueComponent } from '../issue/issue.component';



import { ElipsisModalComponent } from '../../shared/elipsis-modal/elipsis-modal.component';
import { AddComentarioModalComponent } from '../../shared/add-comentario-modal/add-comentario-modal.component';
import { IssueImageComponent } from '../../shared/issue-image/issue-image.component';
import { ContactDataComponent } from '../../shared/contact-data/contact-data.component';
import { IssueData } from '../../shared/issue.data';




@Component({
  selector: 'app-issue-escritorio',
  templateUrl: './issue-escritorio.component.html',
  styleUrls: ['./issue-escritorio.component.scss'],
})
export class IssueEscritorioComponent implements OnInit, OnDestroy {

  @ViewChild(DatatableComponent) table: DatatableComponent;

  @Input() issuePostsaleData: IssueData;
  @Output() rowSelected = new EventEmitter();
  @Output() giveMeIssues = new EventEmitter();
  @Output() updateEvent = new EventEmitter();

  rows: IssueFront[] = [];

  resetRowsSelectedSubscription: Subscription;
  ColumnMode = ColumnMode;
  SelectionType = SelectionType;
  selected = [];
  page = new Page();
  frozenLeft = true;
  supplierUser: BaseUser = new BaseUser();

  constructor(private modalCtrl: ModalController,
              private portalProveedorService: PortalProveedorService,
              private messages: MessagesService,
              private uiService: UiService,
              private issuePopulateService: IssuePopulateService,
              private popOverCtrl: PopoverController,
              private generalPopulateService: GeneralPopulateService,
              ) {

  }

  ngOnDestroy(): void {
    if (this.resetRowsSelectedSubscription) {
      this.resetRowsSelectedSubscription.unsubscribe();
    }
  }

  ngOnInit() {

    this.setPage({ offset: 0 });

    this.messages.onInitTranslateService().subscribe( () => {
      if (this.issuePostsaleData != null) {
        this.rows = this.issuePostsaleData.issuesFront;
      }
      this. resetRowsSelectedSubscription = this.portalProveedorService.issuesPostsaleResetRowsSelectedEvent.subscribe(resp => {
        this.selected = [];
      });
      this.portalProveedorService.getSupplierData().subscribe((baseUser: BaseUser) => {
        this.supplierUser = baseUser;
      });
      this.frozenLeft = this.generalPopulateService.isPlatformDesktop();
    });
  }

  setPage(pageInfo) {
    this.issuePostsaleData.page.offset = pageInfo.offset;
    const envio = {
      page: this.issuePostsaleData.page,
      total: this.issuePostsaleData.page.count
    };
    this.giveMeIssues.emit(envio);
  }

  onSelect({ selected }) {
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
    if (this.selected.length !== 0) {
      this.rowSelected.emit(this.selected);
    } else {
      this.rowSelected.emit(false);
    }
  }

  async abrirDescripcion(value: string) {
    if (value && value.length > 0) {
      const modal = await this.modalCtrl.create({
        component: ElipsisModalComponent,
        componentProps: {
          isModal: true,
          descripcion: value
        }
      });
      await modal.present();
    }
  }

  async abrirAddComment(row: IssueFront, value: string) {
    const modal = await this.modalCtrl.create({
      component: AddComentarioModalComponent,
      componentProps: {
        isModal: true,
        comment: value
      }
    });
    await modal.present();
    modal.onDidDismiss().then(resp => {
      if (resp.data) {
        const commentToSend = resp.data.commentToSend;
        this.enviarComentario(row, commentToSend);
      }
    });
  }

  async openContactData(ev: any, row: IssueFront) {
    const popover = await this.popOverCtrl.create({
      component: ContactDataComponent,
      event: ev,
      componentProps: {
        firstName: row.contact_firstname,
        lastName: row.contact_lastname,
        phone: row.contact_phone,
        email: row.contact_email
      }
    });
    return await popover.present();
  }

  async openIssueImage(ev: Event, row: IssueFront) {
    const modalCtrl = await this.modalCtrl.create({
      component: IssueImageComponent,
      componentProps: {
        issueFront: row,
      }
    });
    return await modalCtrl.present();
  }

  enviarComentario(row: IssueFront, commentToSend: string) {
    const commentsToUpdate: SupplierCommentUpdateDataBase[] = [];
    const supplierCommentUpdateDataBase: SupplierCommentUpdateDataBase = new SupplierCommentUpdateDataBase();
    supplierCommentUpdateDataBase.id = row.id;
    supplierCommentUpdateDataBase.add_comment_supplier = commentToSend;
    supplierCommentUpdateDataBase.add_comment_supplier_name = this.supplierUser.firstname + ' ' + this.supplierUser.lastname;
    commentsToUpdate.push(supplierCommentUpdateDataBase);
    this.portalProveedorService.doSupplierComment(commentsToUpdate).subscribe((ids: number[]) => {
      ids.forEach(id => {
        const issuesFilter: IssuesFilterSupplier = new IssuesFilterSupplier();
        issuesFilter.id = id;
        this.portalProveedorService.getPostSaleIssuesFromCsiteSupplier('all', issuesFilter, null, 0, 0)
          .subscribe((issue: QuproList<IssueSupplier>) => {
            const updateIssue = this.issuePopulateService.convertirIssueSupplierToPostsaleFrontIssue(issue.elements[0]);
            const message = 'Comentario en id: ' + updateIssue.id + ' realizado con éxito.';
            this.showOkToast(message);
            this.updateEvent.emit(updateIssue);
          }, (error: QuproServiceError) => {
            const message = 'id: ' + row.id + ': ' + error.message;
            this.showErrorToast(message);
          });
      });
    });
  }

  getRowIndex(row: any): number {
    let num = -1;
    this.rows.forEach((issue, k) => {
      if (issue.id === row.id) {
        num = k;
        return;
      }
    });
    return num;
  }

  getHeaderClass({ row, column, value }): any {
    return {
      'cell-center-position': true
    };

  }

  getCellClass({ row, column, value }): any {
    return {
      'cell-center-position': true
    };
  }

  onActivate(event: any) {
    if (event.type === 'click') {
      const row: IssueFront = event.row;
      this.abrirIssueModal(row);
    }
  }

  private showOkToast(message: string) {
    this.uiService.showSimpleBottomToast(message, 2000);
  }

  private showErrorToast(message: string) {
    this.uiService.showMiddleToastWithButton(message, 2000000);
  }

  private async abrirIssueModal(issue: IssueFront) {
    const modal = await this.modalCtrl.create({
      component: IssueComponent,
      componentProps: {issue},
    });
    await modal.present();
  }
}
